// Süsteem → Andmete korrastamine: which rows probably are the same place.
// Only a guess for the "Soovitused" chips; the person ticks and merges.

// "Peetri alevik", "Peetri küla", "Peetri." -> "peetri"
export function cityKey (title) {
  return String(title || '').toLowerCase().replace(/[.,;:/]+/g, ' ')
    .replace(/\s+(küla|alevik|alaevik|alev|vald|linn|vallas)(?=\s|$)/g, ' ')
    .replace(/\s+/g, ' ').trim()
}

// Every spelling that starts like Estonia or Eesti is the one country.
export function countryKey (title) {
  const letters = String(title || '').toLowerCase().replace(/[^a-zõäöüšž]/g, '')
  if (/^(eston|eesti)/.test(letters)) return 'estonia'
  return letters || '#' + title
}

const used = row => row.clients + row.objects

// Groups of two or more, the most used row first, the biggest groups first.
export function suggestions (rows, kind) {
  const key = kind === 'city' ? cityKey : countryKey
  const groups = {}
  for (const row of rows) (groups[key(row.title)] = groups[key(row.title)] || []).push(row)
  return Object.values(groups)
    .filter(group => group.length > 1)
    .map(group => group.slice().sort((a, b) => used(b) - used(a)))
    .sort((a, b) => b.length - a.length || a[0].title.localeCompare(b[0].title, 'et'))
}
